<template>
  <div v-if="!loading" :dir="data.dir" class="mw820">
    <!-- <PageTitleComponent class="red-link" :title="data.title" :description="data.description" /> -->
    <div class="d-flex flex-column ">
      <div class="title_box margin-top-20">
        <h1 class="f28-l30-b  text-center" v-html="data.title"></h1>
        <div class="f22-l30-sb  text-center " v-html="data.subtitle" />
      </div> 
      <div class="f16-l21  text-center margin-top-25" v-html="data.description" />
    </div>
    <form class="formfield-round-border  d-flex flex-column" ref="form" method="POST">
        <div class="d-flex flex-column" >
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[0].data_name" :field="data.form.fields[0]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[1].data_name" :field="data.form.fields[1]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[2].data_name" :field="data.form.fields[2]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[3].data_name" :field="data.form.fields[3]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[4].data_name" :field="data.form.fields[4]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[5].data_name" :field="data.form.fields[5]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[6].data_name" :field="data.form.fields[6]" />
        <FormFieldComponent class="f14-l23-el m-auto" :key="data.form.fields[7].data_name" :field="data.form.fields[7]" />
        <div class="formfield-margin-wrapper col-12 col-xl-6 f14-l23-el m-auto">
          <div class="form-group row form-group-border-bottom align-items-center" >
            <label for="amountdataid nowrap" class="col-auto col-xl-auto col-form-label" style="padding-left: 12px;">{{data.form.fields[8].label}}</label>
              <div class="align-items-center col-6 col-xl-8">
                <input type="text" class="form-control-plaintext additionalclass" id="amountdataid" :name="data.form.fields[8].data_name" v-model="amountdatamanual">
              </div>
            </div>
          </div>
          <div v-show="!amountOk" class="red f14-l23-el m-auto" :id="data.form.fields[8].data_name +`invalid`">{{data.form.fields[8].low_amount}}</div>
        </div>
        <FormFieldComponent v-if="data.form?.fields[9]" class="f14-l23-el m-auto" :key="data.form.fields[9].data_name" :field="data.form.fields[9]" />
      <div class="d-flex flex-row margin-top-20 mw440 justify-content-center">
        <div class="flex-grow-1 padding-5" v-for="(payment,idx) in getSubArray(data.form.payment, 'type', 'button')" :key="idx">
          <ButtonComponent @click="onSubmit(payment.href)" @keyup.enter="onSubmit(payment.href)">
            {{payment.label.text}}
            <ImgImage v-if="payment.label?.image" :img="{'url' : payment.label.image, 'height': payment.label.height}" class="m-auto" />
          </ButtonComponent>
        </div>
      </div>
      <div class="d-flex flex-row margin-top-5 justify-content-center mw440" v-for="(payment,idx) in getSubArray(data.form.payment, 'type', 'link')" :key="idx" >
        <div class="f14-l23-el w-100 pointer dpadding-right-35 justify-content-center" @click="onSubmit(payment.href)" style="display: flex; align-items: center;">
          {{payment.label?.text}}
          <ImgImage :img="{'url' : payment.label.image, 'height': '44'}" class="margin-l-10" />
        </div>
      </div>
    </form>
    <div v-if="data?.more_on_yummi" class="d-flex flex-column margin-top-50 mw820 ">
      <div class="f14-l19 df18-l21 c1f red text-center" v-html="data.more_on_yummi.title"> </div>
      <div class="f14-l19 df18-l21 c1f  text-center margin-top-10" v-html="data.more_on_yummi.description"> </div>
    </div>
  </div>
</template>
<script>
//     /* global $ */
import {fetch3, formSubmit} from '@/modules/configuration.js'
import ButtonComponent from "@/components/form/ButtonComponent"
import FormFieldComponent from "@/components/form/FormFieldComponent"
// import PageTitleComponent from "@/components/PageTitleComponent";
// import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
// import SvgImage from "@/components/generic/SvgImage"
import ImgImage from "@/components/generic/ImgImage.vue"
export default {
  components: {
    FormFieldComponent,
    ButtonComponent,
    // PageTitleComponent,
    // SectionImageComponent,
    // SvgImage,
    ImgImage
  },
  data() {
    return {
      loading: true,
      data: {},
      amountdata: 0,
      amountdatamanual: "",
      amountSelectOther: false
    }
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage);
    this.getData();
  },
  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage)
  },
  computed: {
    amountOk() {
      let minimum = this.data.form.fields[8].min;
      return (this.amountdatamanual >= minimum);
    }
  },
  methods: {
    async getData() {
      const data = await fetch3(this, {
        url: "orders/donation_form",
        method: "get",
        addQueryString: true
      } )
      if (Object.keys(data).length ===0) return ;

      this.data = data;
      this.loading = false;

    },
    getSubArray(arr, property, value) {
      return arr.filter(item => {if (item.ios_only) {return this.$isIOS();}else if (item.google_only){return this.$isGOOGLE();} else {return true;}}).filter(item => item[property] == value);
    },
    receiveMessage(e) {

      // if (Object.prototype.hasOwnProperty.call(e.data, "MeshulamActiveLoader_nauK1M54J") && e.data.MeshulamActiveLoader_nauK1M54J == 1) {
      //   $('#popup-error-message').html("");
      //   $('#popup-error-message-description').html("");
      //   window.location.hash = "#loading";
      // } else if (e.data == "MeshulamCancelBitPayment_nauK1M54J") { // .hasOwnProperty("MeshulamCancelBitPayment_nauK1M54J") && e.data.MeshulamCancelBitPayment_nauK1M54J  == 1){
      //   this.$store.dispatch('hidePopup');
      // }
        if (e.origin === 'https://meshulam.co.il' || e.origin === 'https://sandbox.meshulam.co.il'){
          switch (e.data.action){
            case 'close' :{
                document.getElementsByTagName('iframe')[0].style.setProperty('display','none');
                this.$store.dispatch('hidePopup');
                break;
            }
            case 'payment' :{
              if(e.data.status == 1){
                  // success
                  // this.$store.dispatch('hidePopup');
                }
                break;
              }
            case 'failed_to_load_page':{
            break;
          }
        }
      }

    },
    async onSubmit(action) {
      if (!this.amountOk) {
        return;
      }
      await this.$nextTick();
      let form = this.$refs.form;
      let response = await formSubmit(this, form, action);
      if (response.popup_content || response?.prompt_json?.popup_content) {
        this.$store.dispatch('showPopup', response.popup_content || response?.prompt_json?.popup_content);
      }
    },
    customizeField(field) {
      if (field.data_name == "donation_amount") {
        field["labelClass"] = "col-5 col-xl-5";
        field["inputContainerClass"] = "col-7 col-xl-7";
      }
      return field;
    }
  }
}
</script>
<style scoped>
.background-gradient-red {
  height: 355px;
  width: 335px;
  border-radius: 16px;
  background: radial-gradient(circle, #ff7881 0%, #ef3d49 100%);
  box-shadow: 5px 8px 13px -1px rgba(0, 0, 0, 0.13);
}

.btn1 {
  border: 1px solid #bbbaba;
  /* border-radius: 20px; */
  background: white;
  margin: 0 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  width: 100%;
  height: 70px;
  line-height: 55px !important;
}

.btn-check:checked + .btn1 {
  color: #ef3d49;
  border-color: #ef3d49;
  background-color: #f9f9f9;
}

.btn1-check-mark {
  position: absolute;
  top: 10px;
  right: 20px;
  display: none;
}

.btn-check:checked ~ .btn1-check-mark {
  display: block;
}

.m-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.title_box {
    border: 2px solid red;
    border-radius: 10px;
    padding: 10px 0 10px 0;
  }

@media (min-width: 1200px) {
  .dpadding-right-35 {
    padding-right: 35px;
  }
  .bgdot {
    background: url("@/assets/dotbg.png");
  }
}
</style>